export var AuctionSocketEvent;
(function (AuctionSocketEvent) {
    AuctionSocketEvent["JoinRoom"] = "auction:joinRoom";
    AuctionSocketEvent["LeaveRoom"] = "auction:leaveRoom";
    AuctionSocketEvent["BidsUpdated"] = "auction:bidsUpdated";
})(AuctionSocketEvent || (AuctionSocketEvent = {}));
